import { render, staticRenderFns } from "./createCodeManage.vue?vue&type=template&id=7452c8b8&scoped=true&"
import script from "./createCodeManage.vue?vue&type=script&lang=js&"
export * from "./createCodeManage.vue?vue&type=script&lang=js&"
import style0 from "./createCodeManage.vue?vue&type=style&index=0&id=7452c8b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7452c8b8",
  null
  
)

export default component.exports